import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var StarRisingSVG = function StarRisingSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M32.034,18.863,23.75,17.326,19.723,9.439c-.947-1.857-2.5-1.857-3.446,0L12.25,17.326,3.966,18.863c-2.06.382-2.587,1.951-1.171,3.486l5.9,6.4-1.185,8.89c-.275,2.065,1.026,2.978,2.892,2.03L18,35.813l7.6,3.858c1.866.948,3.167.035,2.892-2.03L27.3,28.751l5.9-6.4C34.621,20.814,34.094,19.245,32.034,18.863Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M22,5.307,25.929,13l.546,1.069,1.185.22,8.455,1.569-6.033,6.543-.77.836.149,1.123L30.64,33.21l-7.528-3.824L22,28.821l-1.112.565L13.36,33.21l1.179-8.846.149-1.123-.77-.836L7.885,15.862l8.455-1.569,1.185-.22L18.071,13,22,5.307m0-3.261c-.664,0-1.328.493-1.831,1.48l-4.278,8.379-8.8,1.634c-2.189.406-2.749,2.073-1.245,3.7l6.272,6.8-1.259,9.445c-.214,1.6.469,2.555,1.627,2.555a3.252,3.252,0,0,0,1.446-.4l8.07-4.1,8.07,4.1a3.252,3.252,0,0,0,1.446.4c1.158,0,1.841-.95,1.627-2.555l-1.259-9.445,6.272-6.8c1.5-1.631.944-3.3-1.245-3.7l-8.8-1.634L23.831,3.526c-.5-.987-1.167-1.48-1.831-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M37.293,24.707A1,1,0,0,1,37,24V22a1,1,0,0,1,2,0v2a1,1,0,0,1-1.707.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M3.293,33.707A1,1,0,0,1,3,33V28a1,1,0,0,1,2,0v5a1,1,0,0,1-1.707.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M35.293,37.707A1,1,0,0,1,35,37V30a1,1,0,0,1,2,0v7a1,1,0,0,1-1.707.707Z"
  }));
};
StarRisingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
StarRisingSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Rising Star")
};
export default withDetailedIcon(StarRisingSVG);